import { Avatar, Flex, Icon } from '@cognite/cogs.js';
import styled from 'styled-components/macro';

export const AuthorAvatar = styled(Avatar)`
  align-self: flex-start;
  margin-right: 8px;
`;

export const CommentBoxWrapper = styled(Flex)`
  margin-bottom: 8px;
`;

export const ChevronIcon = styled(Icon)`
  cursor: pointer;
`;
